// External modules
import styled from '@emotion/styled';
import { css } from '@emotion/core';

// Internal modules
import { getLinkStateStyles } from '@/components/Common';

const errorStyleOverrides = css`
  padding-left: 37px;
`;

const ButtonLink = styled.button`
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.link.default.color};
  cursor: pointer;
  font-size: 13px;
  padding: 0;
  text-decoration: none;
  transition: text-decoration ease-cubic-bezier(0.075, 0.82, 0.165, 1);

  ${({ theme }) => getLinkStateStyles(theme)}
`;

export { ButtonLink, errorStyleOverrides };
